(() => {
  const instances = new WeakMap();

  function init(root) {
    if (!root || instances.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    root.dataset.enhanced = 'true';

    root.querySelectorAll('[data-feature-group]').forEach((group) => {
      const tabs = [...group.querySelectorAll('[data-feature-tab]')];
      const panels = [...group.querySelectorAll('[data-feature-panel]')];
      if (tabs.length < 2 || panels.length < 2) return;

      const activate = (blockId, moveFocus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.featureTab === blockId;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus({ preventScroll: true });
          if (active) centerTab(tab);
        });
        panels.forEach((panel) => {
          const active = panel.dataset.featurePanel === blockId;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      /* Kimi 2026-08-26 · keep the active tab centered inside the
         horizontally scrollable mobile tab strip. */
      const centerTab = (tab) => {
        const strip = tab.closest('.el-a-plus-v9__tabs');
        if (!strip) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const left = tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.featureTab), { signal });
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[nextIndex].dataset.featureTab, true);
        }, { signal });
      });

      activate(tabs[0].dataset.featureTab);
    });
    instances.set(root, controller);
  }

  function destroy(root) {
    const controller = instances.get(root);
    if (controller) controller.abort();
    instances.delete(root);
  }

  document.querySelectorAll('[data-el-a-plus]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-el-a-plus]').forEach(init));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-el-a-plus]').forEach(destroy));
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-feature-panel]');
    const root = event.target.closest('[data-el-a-plus]');
    if (!panel || !root) return;
    const tab = root.querySelector(`[data-feature-tab="${panel.dataset.featurePanel}"]`);
    if (tab) tab.click();
  });
})();
